import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';

const SpirituelDanismanlikPage = () => {
  const services = [
    {
      id: 1,
      title: 'Ruhsal Rehberlik Seansı',
      description: 'İçsel yolculuğunuzda size eşlik eden, ruhsal gelişiminizi destekleyen ve farkındalığınızı artıran özel rehberlik seansları.',
      duration: '60 dakika',
      price: 'Fiyat için iletişime geçin',
      includes: [
        'Kişiye özel ruhsal durum analizi',
        'İçsel blokajların tespiti',
        'Ruhsal gelişim yol haritası',
        'Meditasyon ve nefes teknikleri',
        'Enerji okuma ve yorumlama',
        'Kişisel uygulama önerileri',
        'Seans kaydı (isteğe bağlı)'
      ]
    },
    {
      id: 2,
      title: 'Yaşam Amacı Keşfi',
      description: 'Ruhunuzun bu dünyaya gelme amacını, misyonunuzu ve yaşam yolunuzu keşfetmeniz için derin bir içsel yolculuk.',
      duration: '75 dakika',
      price: 'Fiyat için iletişime geçin',
      includes: [
        'Ruhsal amaç analizi',
        'Yetenekler ve potansiyeller',
        'Yaşam misyonu keşfi',
        'Engeller ve fırsatlar',
        'Eylem planı oluşturma',
        'Motivasyon ve destek',
        'Seans kaydı (isteğe bağlı)'
      ]
    },
    {
      id: 3,
      title: 'İçsel Dönüşüm Danışmanlığı',
      description: 'Eski kalıplardan kurtulma, sınırlayıcı inançları dönüştürme ve yeni bir bilinç düzeyine ulaşma sürecinde rehberlik.',
      duration: '60 dakika',
      price: 'Fiyat için iletişime geçin',
      includes: [
        'Sınırlayıcı inanç tespiti',
        'Eski kalıp analizi',
        'Dönüşüm teknikleri',
        'Bilinç genişletme pratikleri',
        'Affetme ve bırakma çalışmaları',
        'Yeni programlama yöntemleri',
        'Seans kaydı (isteğe bağlı)'
      ]
    },
    {
      id: 4,
      title: 'Rüya Yorumlama & Sembol Analizi',
      description: 'Rüyalarınızın ve hayatınıza gelen sembollerin derin anlamlarını keşfederek, bilinçaltınızın mesajlarını anlayın.',
      duration: '45 dakika',
      price: 'Fiyat için iletişime geçin',
      includes: [
        'Rüya analizi ve yorumlama',
        'Sembol ve arketip çözümlemesi',
        'Bilinçaltı mesajları',
        'Tekrarlayan temalar',
        'Ruhsal işaretler',
        'Uygulama önerileri',
        'Seans kaydı (isteğe bağlı)'
      ]
    }
  ];

  const benefits = [
    {
      icon: 'ri-heart-3-line',
      title: 'İçsel Huzur',
      desc: 'Ruhunuzla bağlantı kurarak derin bir huzur ve denge bulun'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Farkındalık',
      desc: 'Kendinizi ve yaşamınızı daha derin bir perspektifle görün'
    },
    {
      icon: 'ri-compass-3-line',
      title: 'Yön Bulma',
      desc: 'Yaşam amacınızı keşfedin ve doğru yolda ilerleyin'
    },
    {
      icon: 'ri-plant-line',
      title: 'Kişisel Gelişim',
      desc: 'Ruhsal olarak büyüyün ve potansiyelinizi ortaya çıkarın'
    }
  ];

  const suitableFor = [
    'Ruhsal gelişim yolculuğunda olanlar',
    'Yaşam amacını arayanlar',
    'İçsel huzur ve denge isteyenler',
    'Kişisel dönüşüm yaşayanlar',
    'Bilinç genişletmek isteyenler',
    'Ruhsal rehberlik arayanlar'
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-b from-primary-dark to-primary-navy overflow-hidden">
        <div className="absolute inset-0 opacity-10" style={{
          backgroundImage: 'radial-gradient(circle, #D4AF37 1px, transparent 1px)',
          backgroundSize: '50px 50px'
        }}></div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center"
          >
            <div className="inline-block px-6 py-2 bg-gold/20 rounded-full mb-6">
              <span className="text-gold text-sm font-medium uppercase tracking-wider">Spiritüel</span>
            </div>
            <h1 className="font-serif text-5xl lg:text-7xl font-bold text-white mb-6">
              Spiritüel Danışmanlık
            </h1>
            <p className="text-xl text-text-light max-w-3xl mx-auto leading-relaxed">
              Ruhunuzun sesini dinleyin, içsel yolculuğunuzda rehberlik alın ve 
              bilincinizi genişleterek gerçek potansiyelinize ulaşın
            </p>
          </motion.div>
        </div>
      </section>

      {/* Introduction */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center"
          >
            <h2 className="font-serif text-4xl font-bold text-primary-dark mb-6">
              Spiritüel Danışmanlık Nedir?
            </h2>
            <p className="text-text-medium text-lg leading-relaxed mb-6">
              Spiritüel danışmanlık, ruhsal gelişim yolculuğunuzda size eşlik eden, 
              içsel farkındalığınızı artıran ve yaşam amacınızı keşfetmenize yardımcı olan 
              derin bir rehberlik sürecidir.
            </p>
            <p className="text-text-medium text-lg leading-relaxed">
              15+ yıllık deneyimimle, ruhsal yolculuğunuzda size özel rehberlik sunuyor, 
              içsel blokajlarınızı çözmenize ve gerçek potansiyelinize ulaşmanıza destek oluyorum.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Benefits */}
      <section className="py-20 bg-cream">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <h2 className="font-serif text-4xl lg:text-5xl font-bold text-primary-dark mb-4">
              Spiritüel Danışmanlığın Faydaları
            </h2>
            <p className="text-text-medium text-lg">
              Ruhsal gelişim yolculuğunuzda neler kazanırsınız?
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {benefits.map((benefit, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-white rounded-3xl p-8 text-center hover:shadow-2xl transition-all duration-500"
              >
                <div className="w-16 h-16 bg-gold/20 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className={`${benefit.icon} text-gold text-3xl`}></i>
                </div>
                <h3 className="font-serif text-xl font-bold text-primary-dark mb-3">
                  {benefit.title}
                </h3>
                <p className="text-text-medium text-sm leading-relaxed">
                  {benefit.desc}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <h2 className="font-serif text-4xl lg:text-5xl font-bold text-primary-dark mb-4">
              Spiritüel Danışmanlık Hizmetleri
            </h2>
            <p className="text-text-medium text-lg">
              Ruhsal yolculuğunuza özel seanslar
            </p>
          </motion.div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {services.map((service, index) => (
              <motion.div
                key={service.id}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-cream rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500"
              >
                <div className="flex items-start justify-between mb-4">
                  <h3 className="font-serif text-2xl font-bold text-primary-dark flex-1">
                    {service.title}
                  </h3>
                  <div className="w-12 h-12 bg-gold/20 rounded-full flex items-center justify-center ml-4">
                    <i className="ri-sparkling-line text-gold text-xl"></i>
                  </div>
                </div>

                <p className="text-text-medium leading-relaxed mb-6">
                  {service.description}
                </p>

                <div className="flex items-center justify-between mb-6 pb-6 border-b border-gold/20">
                  <div className="flex items-center space-x-2">
                    <i className="ri-time-line text-gold"></i>
                    <span className="text-sm text-text-medium">{service.duration}</span>
                  </div>
                  <div className="text-gold font-semibold">{service.price}</div>
                </div>

                <div className="mb-6">
                  <h4 className="text-sm font-bold text-primary-dark mb-3">Seans İçeriği:</h4>
                  <ul className="space-y-2">
                    {service.includes.map((item, idx) => (
                      <li key={idx} className="flex items-start space-x-2 text-sm text-text-medium">
                        <i className="ri-check-line text-gold mt-0.5 flex-shrink-0"></i>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <Link
                  to="/randevu"
                  className="block w-full py-3 bg-gold text-primary-dark text-center font-semibold rounded-full hover:shadow-lg hover:shadow-gold/50 transition-all duration-300 cursor-pointer whitespace-nowrap"
                >
                  Randevu Al
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Suitable For */}
      <section className="py-20 bg-cream">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h2 className="font-serif text-4xl font-bold text-primary-dark mb-4">
              Kimler İçin Uygun?
            </h2>
            <p className="text-text-medium text-lg">
              Spiritüel danışmanlık, ruhsal gelişim arayanlar için
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {suitableFor.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="flex items-center space-x-4 bg-white rounded-2xl p-6"
              >
                <div className="w-10 h-10 bg-gold/20 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-gold text-lg"></i>
                </div>
                <span className="text-text-medium font-medium">{item}</span>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Process */}
      <section className="py-20 bg-primary-dark">
        <div className="max-w-6xl mx-auto px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <h2 className="font-serif text-4xl lg:text-5xl font-bold text-white mb-4">
              Seans Süreci
            </h2>
            <p className="text-text-light text-lg">
              Spiritüel danışmanlık seansı nasıl ilerler?
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            {[
              { step: '1', title: 'İlk Görüşme', desc: 'İhtiyaçlarınızı dinliyoruz' },
              { step: '2', title: 'Enerji Okuma', desc: 'Ruhsal durumunuzu analiz ediyoruz' },
              { step: '3', title: 'Rehberlik', desc: 'Özel yol haritanızı oluşturuyoruz' },
              { step: '4', title: 'Uygulama', desc: 'Pratikler ve takip desteği' },
            ].map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-primary-navy rounded-2xl p-6 text-center"
              >
                <div className="w-12 h-12 bg-gold/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-gold font-bold text-xl">{item.step}</span>
                </div>
                <h4 className="font-serif text-lg font-bold text-white mb-2">
                  {item.title}
                </h4>
                <p className="text-sm text-text-light">{item.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="font-serif text-3xl lg:text-4xl font-bold text-primary-dark mb-6">
              Ruhsal Yolculuğunuza Başlamaya Hazır mısınız?
            </h2>
            <p className="text-text-medium text-lg mb-8">
              İçsel dönüşümünüz için ilk adımı atın ve gerçek potansiyelinizi keşfedin
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6">
              <Link
                to="/randevu"
                className="px-8 py-4 bg-gold text-primary-dark font-semibold rounded-full hover:scale-105 hover:shadow-2xl hover:shadow-gold/50 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                Hemen Randevu Al
              </Link>
              <a
                href="https://wa.me/905555555555"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="px-8 py-4 border-2 border-primary-dark text-primary-dark font-semibold rounded-full hover:bg-primary-dark hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                WhatsApp ile Sor
              </a>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default SpirituelDanismanlikPage;